export default function DSA_Linear_Search() {
  return <div>DSA_Linear_Search Component</div>;
}
